<!-- @format -->

<div>
  <p>{{ "STUDIES.CROSS_STUDY.GENERAL_INFO" | translate }}</p>

  @if (isCurrentUniversityCourse()) {
    <p class="no-results">{{ "STUDIES.CROSS_STUDY.CURRENT_UNIVERSITY" | translate }}</p>
  }

  @if (!isCurrentUniversityCourse()) {
    <div>
      <div role="heading" [attr.aria-level]="level" class="fudis-heading__lg mt-4 mb-3">{{
        "STUDIES.CROSS_STUDY.NETWORKS" | translate
      }}</div>
      @if (currentUniversityName$ | async; as currentUniversityName) {
        <p class="network-info">
          {{ "STUDIES.CROSS_STUDY.NETWORKS_INFO" | translate: { currentUniversity: currentUniversityName } }}
        </p>
        @if (!validCooperationNetworks?.length) {
          <p class="no-results">
            {{ "STUDIES.CROSS_STUDY.NO_NETWORKS" | translate: { currentUniversity: currentUniversityName } }}
          </p>
        }
      }
      @if (validCooperationNetworks?.length) {
        <sis-description-list [columnCount]="1">
          <dl>
            @for (network of validCooperationNetworks; track network) {
              <ng-template #listItem>
                <dt>{{ network.abbreviation }} {{ network.name | localizedString }}</dt>
                <sis-show-more-text
                  [text]="getNetworkDescription(network) | localizedString"
                  [maxCharsBeforeOverFlow]="isMobileView ? 80 : 200"
                  [showMoreButtonText]="'ARIA_LABEL.SHOW_MORE'"
                  [showLessButtonText]="'ARIA_LABEL.SHOW_LESS'">
                </sis-show-more-text>
              </ng-template>
            }
          </dl>
        </sis-description-list>
      }
    </div>
  }
</div>
